import * as React from "react";
import { forwardRef } from "react";
const SvgPageLast = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.33301 5.96016L7.30561 8.00016L5.33301 10.0402L5.93897 10.6668L8.51754 8.00016L5.93897 5.3335L5.33301 5.96016ZM9.80682 5.3335H10.6663V10.6668H9.80682V5.3335Z", fill: "#4555D6" }));
const ForwardRef = forwardRef(SvgPageLast);
export { ForwardRef as ReactComponent };
